(ns frontend.view.components.tesi-financials
  (:require [common.localization :as loc]
            [reagent.core :as r]
            [frontend.utils :as utils]
            [clojure.string :as string]))

(def row-keys [:revenue :ebitda :cash-and-bank-receivables :interest-bearing-liabilities])

(defn default-row [years]
  (reduce (fn [acc year]
            (assoc acc year nil))
          {}
          years))

(defn default-value []
  (let [d (js/Date.)
        current-year (.getFullYear d)
        years (range (- current-year 3) (+ current-year 1))]
    (reduce (fn [acc row-key]
              (assoc acc row-key (default-row years)))
            {:currency :eur}
            row-keys)))

(defn financials-table-cell-edit-view [{:keys [value on-change]}]
  (let [raw-input (r/atom value)]
    (fn [{:keys [value on-change]}]
      [:input.oppo-financials-cell__input
       {:type      "text"
        :value     @raw-input
        :on-change (fn [e]
                     (let [input (-> e .-target .-value)
                           float-info (utils/parse-float-info input nil)
                           float-value (:float-value float-info)]
                       (reset! raw-input input)
                       (on-change (if (nil? float-value) nil float-value))))}])))

(defn financials-table-row [{:keys [value edit? on-change row-key years]}]
  (let [row-data (get value row-key)]
    [:tr.oppo-financials-row
     [:td.oppo-financials-cell.oppo-financials-cell--header (loc/tr row-key)]
     (doall (for [year years
                  :let [cell-value (get row-data year)]]
              ^{:key (str "financials-table-tbody-row-td-" year)}
              [:td.oppo-financials-cell
               {:key year}
               (if edit?
                 [financials-table-cell-edit-view
                  {:value     cell-value
                   :on-change (fn [new-value]
                                (on-change (assoc-in value [row-key year] new-value)))}]
                 (if (number? cell-value)
                   (utils/format-with-separators cell-value)
                   cell-value))]))]))

(defn financials-table-head-view
  [{:keys [value edit? on-change years currency currencies]}]
  [:thead
   [:tr.oppo-financials-header-row
    (concat
     [[:th.oppo-financials-cell
       {:key "currency-selector"}
       (if edit?
         [:select.oppo-financials-currency-selector
          {:value     (if currency currency "")
           :on-change (fn [e]
                        (on-change (assoc value
                                     :currency
                                     (-> e .-target .-value keyword))))}
          (utils/add-separator
           (doall (for [[k v] currencies]
                    ^{:key (str "financials-table-thead-currency-selector-" k)}
                    [:option
                     {:key   k
                      :value k}
                     v])))]
         [:span (string/upper-case (->> currencies
                                        (filter (fn [[k v]]
                                                  (= k currency)))
                                        first
                                        first
                                        name
                                        str))])]]
     (doall (for [year years]
              ^{:key (str "financials-table-thead-th-" year)}
              [:th.oppo-financials-cell.oppo-financials-cell--header
               {:key year}
               year])))]])

(defn financials-view [{:keys [value currencies edit? on-change]}]
  (let [value (or value (default-value))
        years (->> (dissoc value :currency)
                   vals
                   (map keys)
                   (apply concat)
                   distinct
                   sort)]
    [:table.oppo-financials
     [financials-table-head-view
      {:value      value
       :edit?      edit?
       :on-change  on-change
       :years      years
       :currency   (:currency value)
       :currencies currencies}]
     [:tbody
      (doall (for [row-key row-keys]
               ^{:key (str "financials-table-tbody-row-" row-key)}
               [financials-table-row {:key       row-key
                                      :value     value
                                      :edit?     edit?
                                      :on-change on-change
                                      :row-key   row-key
                                      :years     years}]))]]))
